import React, { ReactElement } from "react";
import { ChevronLeft } from "react-feather";
import Circle from "../Circle/Circle";
import styles from "./BackButton.module.css";

interface BackButtonProps {
  /**
   * Custom class name to be added to the button
   */
  className?: string;
  /**
   * Text to display inside the button
   */
  text: string;
  /**
   * A11y name to apply to the button
   */
  name: string;
  /**
   *  Function to call on click
   */
  onClick: (ev: React.MouseEvent<HTMLButtonElement>) => void;
}

const BackButton: React.FC<BackButtonProps> = ({
  className = "BackButton",
  text,
  name,
  onClick,
  ...rest
}): ReactElement => {
  return (
    <button {...rest} className={styles.BackButton} onClick={onClick}>
      <Circle color="#37519d" size={24}>
        <ChevronLeft size={20} color="white" />
      </Circle>
      <span>{text}</span>
    </button>
  );
};

export default BackButton;
